export default __webpack_public_path__ + "static/media/gem_red.35d43aab.png";